export default '1.2.4';



/** WEBPACK FOOTER **
 ** ./src/lib/version.js
 **/